import $ from "cash-dom";
// import { cart } from './cart'

const progressBarComponent = $('[data-component="cart-progress-bar"]');
const priceThreshold = parseFloat(
	progressBarComponent.attr("data-price-threshold"),
);

const beforePanel = $('[data-element="cart-before-threshold"]');
const afterPanel = $('[data-element="cart-after-threshold"]');

const progressBubble = $('[data-element="cart-progress-bar-bubble"]');
const progressPrice = $('[data-element="cart-progress-bar-price"]');
const progressBar = progressBarComponent.find(".bar");

const updateProgressBar = (data) => {
	// exit if not enabled
	if (progressBarComponent.length == 0) return;

	const cartPrice = data.items_subtotal_price / 100;
	const delta = Math.ceil(priceThreshold - cartPrice);

	if (delta <= 0) {
		aboveThreshold();
	} else {
		let leftPos = 1 - delta / priceThreshold;
		progressBar[0].style.width = `${leftPos * 100}%`;

		if (leftPos > 0.95) {
			leftPos = `calc(${leftPos * 100}% - 45px)`;
		} else if (leftPos > 0.1) {
			leftPos = `calc(${leftPos * 100}% - 34px)`;
		} else {
			leftPos = `calc(${leftPos * 100}% - 10px)`;
		}

		progressPrice.html("$" + delta);
		progressBubble[0].style.left = leftPos;
		belowhreshold();
	}
};

const aboveThreshold = () => {
	beforePanel.attr("aria-hidden", "true");
	afterPanel.attr("aria-hidden", "false");
};

const belowhreshold = () => {
	beforePanel.attr("aria-hidden", "false");
	afterPanel.attr("aria-hidden", "true");
};

export { updateProgressBar };
